import {
  RingWrap,
  RingSvg,
  TrackCircle,
  ProgressCircle,
  Center,
  PercentText,
  RingLabel,
} from './styled'
import { CompletenessRingProps } from './types'

const DEFAULT_SIZE = 88
const DEFAULT_STROKE = 8

/**
 * Circular completeness ring driven by a 0–100 percent value. Renders
 * an SVG track + progress arc with the percent label in the centre.
 *
 * @param {CompletenessRingProps} props
 * @returns {JSX.Element}
 */
const CompletenessRing = ({
  percent,
  size = DEFAULT_SIZE,
  strokeWidth = DEFAULT_STROKE,
  label = 'Complete',
}: CompletenessRingProps): JSX.Element => {
  const clampedPercent = Math.max(0, Math.min(100, percent))
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const dashOffset = circumference * (1 - clampedPercent / 100)

  return (
    <RingWrap style={{ width: `${size}px`, height: `${size}px` }}>
      <RingSvg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <TrackCircle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
        />
        <ProgressCircle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
        />
      </RingSvg>
      <Center>
        <PercentText>{Math.round(clampedPercent)}%</PercentText>
        <RingLabel>{label}</RingLabel>
      </Center>
    </RingWrap>
  )
}

export default CompletenessRing
